module.exports = __webpack_public_path__ + "templates/notifications.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/notifications/templates/notifications.html
// module id = 9W2n
// module chunks = 1